const firstFourWithCommonFormat = [
  '4026',
  '4405',
  '4508',
  '4844',
  '4913',
  '4917',
  '6011',
  '6011',
  '6011',
  '5019',
]

const firstTwoWithCommonFormat = [
  '51',
  '52',
  '53',
  '54',
  '55',
  '65',
]

export const formatCardNumber = (value = '') => {

  const cardNumber = value.split('-').join('').trim()
  if (cardNumber.length <= 4) return cardNumber

  const cardHasCommonFormat = firstFourWithCommonFormat.includes(cardNumber.substring(0, 4))
    || firstTwoWithCommonFormat.includes(cardNumber.substring(0, 2))
    || cardNumber.startsWith('4')

  // return card number with max length 19 if card does not have a common format
  if (!cardHasCommonFormat) return cardNumber.slice(0, 19)

  const numberOfSubstrings = Math.ceil(cardNumber.length / 4)
  const substrings = []

  Array.from({ length: numberOfSubstrings }, (_, i) => i).forEach(i => {
    substrings.push(cardNumber.substring(i * 4, i * 4 + 4))
  })

  return cardNumber.startsWith('4')
    ? substrings.slice(0, 5).join('-')
    : substrings.slice(0, 4).join('-')
}